<template>
  <div class="page-vacancy-admin">
      <div class="page-vacancy-admin__vacancies-info-block">
        <div class="page-vacancy-admin__vacancies-info">
          <div class="page-vacancy-admin__vacancies-name">
            <h4 class="page-vacancy-admin__vacancies-title">
              {{ vacancy.title }}
            </h4>

            <div>
              <h4 class="page-vacancy-admin__vacancies-price" v-if="vacancy.salary_from">
                от {{ getFormattedSalary(vacancy.salary_from) }} <span v-if="vacancy.salary_to"> до {{ getFormattedSalary(vacancy.salary_to) }} </span> ₽
              </h4>

              <h4 class="page-vacancy-admin__vacancies-price" v-else>
                По договоренности
              </h4>
            </div>
          </div>

          <div class="page-vacancy-admin__vacancies-status">
            <p v-if="vacancy.is_active === true" class="active"> Активна </p>
            <p v-else class="inactive"> Неактивна </p>
          </div>

          <div class="page-vacancy-admin__vacancies-data">
            <div class="page-vacancies__vacancies-location m-t-u color--main-ground-light">
              <IconLocation class="mr-4"/>
              {{ vacancy.city }}
            </div>
            <div class="page-vacancies__vacancies-date m-t-u color--main-ground-light">
              <IconCalendar class="mr-4"/>
              Опубликовано <span v-if="vacancy.start_published"> {{ getDateFormatISO(vacancy.start_published) }} </span>
            </div>
          </div>

        </div>

        <div class="page-vacancy-admin__vacancies-button">
          <div class="button-edit">
            <a :href="`/vacancy/update/${vacancy.id}`">
              <iconEdit/>
            </a>
          </div>
          <div class="button-delete"
               @click="deleteVacancy(vacancy.id)">
            <iconDelete/>
          </div>
        </div>
      </div>

      <div class="page-vacancy-admin__dividing-line"></div>

  </div>
</template>

<script>
import IconLocation from '../../icons/icon-location'
import IconCalendar from '../../icons/icon-calendar'
import IconEdit from '../../icons/icon-edit'
import IconDelete from '../../icons/icon-delete'
import { formatTimeISO } from "../../../app/utils/utils";
import { formatSalary } from "../../../app/utils/utils";

export default {
  name: 'vacancyAdmin',
  components: {
    IconLocation,
    IconCalendar,
    IconEdit,
    IconDelete
  },

  props: {
    vacancy: { type: Object, default: () => {}, required: false },
  },

  data() {
    return {
    }
  },

  methods: {
    getDateFormatISO(date) {
      return formatTimeISO(date)
    },

    getFormattedSalary(salary) {
      return formatSalary(salary)
    },

    deleteVacancy(id) {
      this.$emit('delete-vacancy', id)
    },
  }
}
</script>
